export default "__VITE_ASSET__BZRaCtM2__"